import {twMerge} from '../../../common/twMerge';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';

export function ErrorAreaDetailText({
  children,
  className,
  ...props
}: ErrorAreaChildProps) {
  return (
    <div
      className={twMerge(
        'text-center whitespace-pre-wrap break-all font-small1 text-theme-solid-60',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export const ErrorAreaDetailTextType = (<ErrorAreaDetailText />).type;
